import type { AppStore } from "@src/stores/AppStore";
import type { BaseStore } from "@src/stores/BaseStore";
import type { PlanningUtilizationState } from "@src/stores/forms/SettingsModalState/PlanningUtilizationState";

export class PlanningUtilizationSettingsStore implements BaseStore {
  constructor(
    public appStore: AppStore,
    public form: PlanningUtilizationState,
  ) {}
}
